module.exports = __webpack_public_path__ + "static/media/Iowa Bar Logo.eff0dcd1.png";